import React, { useState } from "react";

import { LabelSIM } from "../../components/Mobile/LabelSIM";
import { setField } from "../../../../store/order/actions";
import { useDispatch, useSelector } from "react-redux";
import { LabelSIMWarning } from "./LabelSIMWarning";

interface LabelSIMContainerProps {
  cardIndex: string;
}

export const LabelSIMContainer = ({ cardIndex }: LabelSIMContainerProps) => {
  const [showLabelSIMWarning, setShowLabelSIMWarning] =
    useState<boolean>(false);
  const dispatch = useDispatch();
  const order = useSelector((state: any) => state.order);
  const labelSIM = order.labelSIM;

  const setLabelSIM = (showLabelSIMWarning: boolean, labelSIM: boolean) => {
    setShowLabelSIMWarning(showLabelSIMWarning);
    dispatch(setField("labelSIM", labelSIM));
  };

  return (
    <>
      <LabelSIM
        cardIndex={cardIndex}
        labelSIM={labelSIM}
        onLabelSIMChange={() => setLabelSIM(!labelSIM, !labelSIM)}
      />
      <LabelSIMWarning
        handleYes={() => setLabelSIM(false, true)}
        handleNo={() => setLabelSIM(false, false)}
        show={showLabelSIMWarning}
      />
    </>
  );
};
